;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require("babel-runtime/helpers/toConsumableArray");

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _axios = require("axios");

var _axios2 = _interopRequireDefault(_axios);

var _sweetalert = require("sweetalert2");

var _sweetalert2 = _interopRequireDefault(_sweetalert);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: ["post_url", "merchants", "accounts_url", "currencies", "index_page", "csrf_token", "initiate_transfer_url", "allow_eft_withdrawals", "gateways_url", "gateways_search_url", "withdrawal_endpoint_url", "csrf_token"],
  data: function data() {
    return {
      merchantsList: [],
      accounts: [],
      merchant_id: "",
      currency_id: "",
      selectedAccounts: [],
      allAccountsSelected: false,
      displayAccounts: [],
      loading: true,
      decodedCurrencies: [],
      changeset: {},
      validAmount: false,
      bank_accounts: [],
      payment_gateways: [],
      amount: null,
      step: 1,
      bankAccountId: null,
      gatewayId: null,
      transferType: null,
      account_name: null,
      account_id: null,
      otp_reference: null,
      withdrawing: false
    };
  },

  computed: {},
  mounted: function mounted() {
    this.merchantsList = JSON.parse(this.merchants);
    this.decodedCurrencies = JSON.parse(this.currencies);
    if (this.merchantsList.length == 1) {
      this.merchant_id = this.merchantsList[0].id;
      this.preloadAccounts();
    }
  },

  watch: {
    selectedAccounts: function selectedAccounts() {
      var _this = this;

      if (this.selectedAccounts.includes("all")) {
        this.allAccountsSelected = true;
      } else {
        this.allAccountsSelected = false;
        this.accounts = this.accounts.filter(function (account) {
          return !_this.selectedAccounts.includes(account.id) && !_this.selectedAccounts.includes("all");
        });
      }
      this.fetchAccounts();
    }
  },
  methods: {
    preloadAccounts: function preloadAccounts() {
      var _this2 = this;

      if (this.merchant_id == "" || this.currency_id == "") {
        return;
      } else {
        _axios2.default.get(this.accounts_url + "?merchant_id=" + this.merchant_id + "&currency_id=" + this.currency_id).then(function (response) {
          if (response.status == 200) {
            _this2.accounts = response.data.accounts;
          }
        });
      }
    },

    fetchAccounts: function fetchAccounts() {
      var _this3 = this;

      var account_ids = [].concat((0, _toConsumableArray3.default)(this.accounts.map(function (account) {
        return account.id;
      })));
      if (this.allAccountsSelected) {
        _axios2.default.post(this.accounts_url, { account_ids: account_ids }).then(function (response) {
          if (response.status == 200) {
            _this3.displayAccounts = response.data.accounts;
            _this3.selectedAccounts = account_ids;
          }
        });
      } else {
        if (this.selectedAccounts.length) {
          _axios2.default.post(this.accounts_url, { account_ids: this.selectedAccounts }).then(function (response) {
            if (response.status == 200) {
              _this3.displayAccounts = response.data.accounts;
            }
          });
        } else {
          this.displayAccounts = [];
        }
      }
    },

    checkAmount: function checkAmount(account) {
      if ((account.amount != null || account.amount != "0") && account.amount <= account.balance) {
        this.loading = false;
        this.validAmount = true;
      } else {
        this.validAmount = false;
        this.changeset = { errors: "Invalid amount" };
      }
    },

    removeAccount: function removeAccount(account) {
      this.allAccountsSelected = false;
      this.selectedAccounts = this.selectedAccounts.filter(function (item) {
        return item != account.id;
      });
      this.fetchAccounts();
      this.preloadAccounts();
    },

    updateBankAccounts: function updateBankAccounts() {
      var _this4 = this;

      if (this.transferType == 'eft') {
        _axios2.default.get(this.gateways_url).then(function (response) {
          if (response.data.status == "ok") {
            _this4.payment_gateways = response.data.gateways;
          }
        });
      } else {
        _axios2.default.get(this.gateways_search_url, { params: { bankAccountId: this.bankAccountId } }).then(function (response) {
          _this4.payment_gateways = response.data;
        });
      }
    },

    withdrawFunds: function withdrawFunds() {
      var _this5 = this;

      var confirmSubmit = confirm("Are you sure ?");
      var self = this;
      if (confirmSubmit && this.displayAccounts.length) {
        var payload = {
          accounts: this.displayAccounts,
          merchant_id: this.merchant_id,
          currency_id: this.currency_id,
          transfer_type: this.transferType
        };
        _axios2.default.post(this.post_url, { withdraw: payload }).then(function (response) {
          if (response.data.status == "ok") {
            self.payment_gateways = response.data.payment_gateways;
            self.bank_accounts = response.data.bank_accounts;
            self.amount = response.data.amount;
            self.banks = response.data.banks;
            self.changeset = {};
            self.step = 2;
          } else {
            _this5.changeset = { message: response.data.errors };
          }
        }).catch(function (error) {});
      } else {
        return;
      }
    },

    submitWithdrawal: function submitWithdrawal() {
      var _this6 = this;

      var confirmSubmit = confirm("Are you sure ?");
      if (confirmSubmit && this.bankAccountId != null && this.gatewayId != null) {
        this.withdrawing = true;
        var payload = {
          accounts: this.displayAccounts,
          merchant_id: this.merchant_id,
          currency_id: this.currency_id,
          amount: this.amount,
          payment_gateway_id: this.gatewayId,
          bank_account_id: this.bankAccountId,
          transfer_type: this.transferType
        };
        _axios2.default.post(this.initiate_transfer_url, {
          _csrf_token: this.csrf_token,
          withdraw: payload
        }).then(function (res) {
          _this6.withdrawing = true;
          if (res.data.status == "ok") {
            _sweetalert2.default.fire({
              position: "top-end",
              icon: "success",
              title: "Successful request",
              text: "A withdrawal request has been submitted.",
              timer: 3000
            }).then(function () {
              if (!res.data.proxy) {
                location.href = _this6.index_page;
              } else {
                _this6.account_id = res.data.account_id;
                _this6.account_name = res.data.account_name;
                _this6.otp_reference = res.data.reference;

                document.querySelector('input[name="account_id"]').value = _this6.account_id;
                document.querySelector('input[name="account_name"]').value = _this6.account_name;
                document.querySelector('input[name="reference"]').value = _this6.otp_reference;
                var form = document.getElementById("proxy");
                form.submit();
              }
            });
          } else {
            _this6.withdrawing = !true;
            _this6.changeset = { message: res.data.errors };
          }
        });
      } else {
        this.changeset = {
          message: "Please select destination account and payment gateway"
        };
        return;
      }
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.step == 1)?_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit.apply(null, arguments)}}},[(_vm.changeset.message != null)?_c('div',{staticClass:"alert alert-danger",attrs:{"role":"alert"}},[_vm._v("\n      "+_vm._s(_vm.changeset.message)+"\n    ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.merchantsList.length > 1),expression:"merchantsList.length > 1"}],staticClass:"mb-3"},[_c('label',[_vm._v("Merchant")]),_vm._v(" "),_c('select2',{staticClass:"form-control",on:{"change":_vm.preloadAccounts},model:{value:(_vm.merchant_id),callback:function ($$v) {_vm.merchant_id=$$v},expression:"merchant_id"}},[_c('option',{attrs:{"value":""}},[_vm._v("Select merchant")]),_vm._v(" "),_vm._l((_vm.merchantsList),function(merchant){return _c('option',{key:merchant.id,domProps:{"value":merchant.id}},[_vm._v("\n            "+_vm._s(merchant.name)+"\n          ")])})],2)],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Currency")]),_vm._v(" "),_c('select2',{staticClass:"form-control",on:{"change":_vm.preloadAccounts},model:{value:(_vm.currency_id),callback:function ($$v) {_vm.currency_id=$$v},expression:"currency_id"}},[_c('option',{attrs:{"value":""}},[_vm._v("Select Currency")]),_vm._v(" "),_vm._l((_vm.decodedCurrencies),function(currency){return _c('option',{key:currency.id,domProps:{"value":currency.id}},[_vm._v("\n            "+_vm._s(currency.symbol)+"\n          ")])})],2)],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.accounts.length > 0),expression:"accounts.length > 0"}],staticClass:"form-group mb-3"},[_c('label',[_vm._v("Accounts")]),_vm._v(" "),_c('select2',{attrs:{"multiple":""},model:{value:(_vm.selectedAccounts),callback:function ($$v) {_vm.selectedAccounts=$$v},expression:"selectedAccounts"}},[_c('option',{attrs:{"value":"all"}},[_vm._v("Select all")]),_vm._v(" "),_vm._l((_vm.accounts),function(account){return _c('option',{key:account.id,domProps:{"value":account.id}},[_vm._v("\n            "+_vm._s(account.name)+"\n          ")])})],2)],1),_vm._v(" "),(_vm.displayAccounts && _vm.displayAccounts.length > 0)?_c('div',{staticClass:"form-group mb-3 border-bottom"},_vm._l((_vm.displayAccounts),function(account){return _c('div',{key:account.id},[_c('div',{staticClass:"form-row mb-3"},[_c('div',{staticClass:"form-group col-md-4"},[_c('label',[_vm._v("Account name")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"text","readonly":""},domProps:{"value":account.name}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-3"},[_c('label',[_vm._v("Account balance")]),_vm._v(" "),_c('input',{staticClass:"form-control",class:{ 'is-invalid': account.balance == 0 },attrs:{"type":"number","readonly":""},domProps:{"value":account.balance}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-3"},[_c('label',[_vm._v("Amount to withdraw")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(account.amount),expression:"account.amount"}],staticClass:"form-control",class:{ 'is-invalid': account.balance == 0 },attrs:{"type":"number","min":"0","max":account.balance,"disabled":account.balance == 0,"required":""},domProps:{"value":(account.amount)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(account, "amount", $event.target.value)},function($event){return _vm.checkAmount(account)}]}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-2 mt-4"},[_c('div',{staticClass:"btn btn-outline-danger",on:{"click":function($event){return _vm.removeAccount(account)}}},[_c('i',{staticClass:"fe fe-minus-circle"},[_vm._v(" Remove")])])])])])}),0):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedAccounts.length >= 1),expression:"selectedAccounts.length >= 1"}],staticClass:"row mb-3"},[_c('div',{staticClass:"col-6 mt-3"},[_c('button',{staticClass:"btn btn-block btn-outline-secondary",attrs:{"type":"button"},on:{"click":function($event){return _vm.window.location.reload()}}},[_vm._v("\n            Cancel\n          ")])]),_vm._v(" "),_c('div',{staticClass:"col-6 mt-3"},[_c('button',{staticClass:"btn btn-block btn-outline-primary",attrs:{"type":"button","disabled":_vm.loading},on:{"click":_vm.withdrawFunds}},[_vm._v("\n            Proceed\n          ")])])])])]):_vm._e(),_vm._v(" "),(_vm.step == 2)?_c('form',[(_vm.withdrawing)?_c('div',{staticClass:"d-flex align-items-center"},[_c('strong',[_vm._v("Please wait, withdrawal in progress...")]),_vm._v(" "),_c('div',{staticClass:"spinner-border ml-auto",attrs:{"role":"status","aria-hidden":"true"}})]):_vm._e(),_vm._v(" "),(_vm.changeset.message != null)?_c('div',{staticClass:"alert alert-danger",attrs:{"role":"alert"}},[_vm._v("\n      "+_vm._s(_vm.changeset.message)+"\n    ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Destination Account")]),_vm._v(" "),_c('select2',{attrs:{"required":""},model:{value:(_vm.bankAccountId),callback:function ($$v) {_vm.bankAccountId=$$v},expression:"bankAccountId"}},[_c('option',[_vm._v("Select Bank Account...")]),_vm._v(" "),_vm._l((_vm.bank_accounts),function(account){return _c('option',{key:account.id,domProps:{"value":account.id}},[_vm._v("\n            "+_vm._s(account.name)+"\n          ")])})],2)],1),_vm._v(" "),(_vm.allow_eft_withdrawals == 'true')?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Select the type of transfer")]),_vm._v(" "),_c('select2',{attrs:{"required":""},on:{"change":_vm.updateBankAccounts},model:{value:(_vm.transferType),callback:function ($$v) {_vm.transferType=$$v},expression:"transferType"}},[_c('option',{attrs:{"value":""}},[_vm._v("Select transfer type...")]),_vm._v(" "),_c('option',{attrs:{"value":"interbank"}},[_vm._v("Internal Funds Transfer")]),_vm._v(" "),_c('option',{attrs:{"value":"eft"}},[_vm._v("External Funds Transfer")])])],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Withdraw Through... ")]),_vm._v(" "),_c('select2',{attrs:{"required":""},model:{value:(_vm.gatewayId),callback:function ($$v) {_vm.gatewayId=$$v},expression:"gatewayId"}},[_c('option',[_vm._v("Select gateway...")]),_vm._v(" "),_vm._l((_vm.payment_gateways),function(gateway){return _c('option',{key:gateway.id,domProps:{"value":gateway.id}},[_vm._v("\n          "+_vm._s(gateway.name)+"\n        ")])})],2)],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Amount to Withdraw")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"number","readonly":""},domProps:{"value":_vm.amount}})]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-6 mt-3"},[_c('button',{staticClass:"btn btn-block btn-outline-secondary",attrs:{"type":"button","disabled":_vm.withdrawing},on:{"click":function($event){return _vm.window.location.reload()}}},[_vm._v("\n          Cancel\n        ")])]),_vm._v(" "),_c('div',{staticClass:"col-6 mt-3"},[_c('button',{staticClass:"btn btn-block btn-outline-primary",attrs:{"type":"button","disabled":_vm.withdrawing},on:{"click":_vm.submitWithdrawal}},[_vm._v("\n          Submit\n        ")])])])]):_vm._e(),_vm._v(" "),_c('form',{attrs:{"id":"proxy","action":_vm.withdrawal_endpoint_url,"method":"POST"}},[_c('input',{attrs:{"type":"hidden","name":"_csrf_token"},domProps:{"value":_vm.csrf_token}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"merchant_id","id":"merchant_id"},domProps:{"value":_vm.merchant_id}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"amount","id":"amount"},domProps:{"value":_vm.amount}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"transfer_type","id":"amount"},domProps:{"value":_vm.transferType}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"currency_id","id":"currency_id"},domProps:{"value":_vm.currency_id}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"gateway_id","id":"gateway_id"},domProps:{"value":_vm.gatewayId}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"account_id","id":"account_id"},domProps:{"value":_vm.account_id}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"account_name","id":"account_name"},domProps:{"value":_vm.account_name}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"reference","id":"reference"},domProps:{"value":_vm.otp_reference}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"accounts"},domProps:{"value":JSON.stringify(_vm.displayAccounts)}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"form_request_type","value":"batch_withdrawal"}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"bank_account_id","id":"bank_account_id"},domProps:{"value":_vm.bankAccountId}})])])}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7a365852", __vue__options__)
  } else {
    hotAPI.reload("data-v-7a365852", __vue__options__)
  }
})()}